"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _alertActive = _interopRequireDefault(require("@teladoc/pulse/icons/alert-active.svg"));
var _FormGroupErrorModule = _interopRequireDefault(require("./FormGroupError.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const FormGroupError = _ref => {
  let {
    className,
    testAttr,
    id,
    title,
    errors
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cnbuilder.cnb)(_FormGroupErrorModule.default.root, className),
    "aria-live": "polite",
    role: "alert",
    "data-testid": testAttr,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertActive.default, {
      className: _FormGroupErrorModule.default.icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _FormGroupErrorModule.default.content,
      id: id,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _FormGroupErrorModule.default.title,
        children: title
      }), Array.isArray(errors) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        children: errors.map((error, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: error.details || error.message
        }, i))
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: errors.details || errors.message
      })]
    })]
  });
};
FormGroupError.defaultProps = {
  testAttr: 'form-group-error'
};
var _default = exports.default = FormGroupError;